var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02934 -4.34549e-07C5.08586 0.0472117 5.16294 0.104191 5.23145 0.169311C6.70447 1.56777 8.18947 2.95809 9.63851 4.37934C9.8509 4.58772 10.0273 4.95565 9.99649 5.22753C9.96908 5.47661 9.68304 5.76477 9.43126 5.90804C9.10582 6.092 8.73415 5.98455 8.45324 5.72244C7.84348 5.15101 7.23886 4.57633 6.63424 4.00001C6.10156 3.49207 5.57059 2.98251 5.01392 2.45015C4.88204 2.56737 4.76728 2.66342 4.65937 2.76598C3.64881 3.72325 2.64853 4.69029 1.62941 5.63941C1.01623 6.20922 0.187225 6.06595 0.0193701 5.34474C-0.038866 5.09403 0.0364982 4.70494 0.21463 4.53074C1.775 3.00367 3.37134 1.51242 4.9574 0.00976709C4.96597 0.00325493 4.98481 0.00651077 5.02934 0.00162653L5.02934 -4.34549e-07Z",
    fill: "#3E3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.50e2f87282b8f7c3a5b9c8db5c45e2c8.svg";
export { ForwardRef as ReactComponent };